import { useState } from 'react';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { Plus } from 'lucide-react';

import { Tooltip } from '@/components/Tooltip/Tooltip';

import { CONTENT_TYPE_OPTIONS } from './AddContentPicker';
import type { AddableContentType } from './editorTypes';
import styles from './EditableUnitFrame.module.css';

interface DividerInsertButtonProps {
  onAdd: (type: AddableContentType) => void;
}

export function DividerInsertButton({ onAdd }: DividerInsertButtonProps) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className={styles.divider} data-edit-divider="boundary">
      <DropdownMenu.Root modal={false} onOpenChange={setIsOpen} open={isOpen}>
        {/* No click handler of its own: Radix opens the menu on the press,
            and one opening it on the click reopened it as a second press
            closed it (review of PR 116). */}
        <Tooltip content="Insert Content">
          <DropdownMenu.Trigger asChild>
            <button
              aria-label="Insert Content"
              className={styles.insertButton}
              title="Insert Content"
              type="button"
            >
              <Plus aria-hidden="true" size={14} strokeWidth={2.4} />
            </button>
          </DropdownMenu.Trigger>
        </Tooltip>
        <DropdownMenu.Portal>
          <DropdownMenu.Content
            align="center"
            aria-label="Insert content types"
            className={styles.insertMenu}
            sideOffset={18}
          >
            {CONTENT_TYPE_OPTIONS.map((option) => (
              <DropdownMenu.Item
                className={styles.insertOption}
                key={option.type}
                onSelect={() => {
                  onAdd(option.type);
                  setIsOpen(false);
                }}
              >
                <option.Icon aria-hidden="true" size={16} strokeWidth={2} />
                <span className={styles.insertOptionLabel}>{option.label}</span>
              </DropdownMenu.Item>
            ))}
          </DropdownMenu.Content>
        </DropdownMenu.Portal>
      </DropdownMenu.Root>
    </div>
  );
}
